import React , { useState,useContext, useEffect,useRef }from 'react'
import { StateContext } from '../../../state';
import http from '../../../../../utils/server'
import { Line } from '@ant-design/charts';
import html2canvas from 'html2canvas';
import { SearchOutlined} from '@ant-design/icons';
import * as echarts from 'echarts';
import { Select, Button,   Table, Tabs,  message, DatePicker, Spin, Checkbox } from 'antd'
import moment from 'moment';
import { Mode } from '../../../../../App';
import './device.less'
import { StateDeviceContext } from '../../../state_device';
let todayTime=0;
const { Option } = Select;
const { RangePicker } = DatePicker;
function formatDateTimes(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
};
function dateStart() {
    var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
    return now_date;
}
function DeviceHistory(props) {
    const { state, dispatch } = useContext(StateContext)
    const [showSelDevNodes,setShowSelDevNodes] = useState([]);//要查询设备的所有测点
    const [selDevNodes,setSelDevNodes] = useState([]);//要查询设备的所有测点
    const [showSelDevNodesValue,setShowSelDevNodesValue] = useState([]);//要查询设备的所有测点名字
    const [indeterminate, setIndeterminate] = useState(false); //要查询设备的所有测点是否全选
    const [checkAll, setCheckAll] = useState(true);//要查询设备的所有测点设置全选
    const [checkedList,setCheckedList] = useState([]);//要查询的测点的id
    const [selNode, setSelNode] = useState([]);//要查询的测点的node
    const [selNodeColums, setSelNodeColums] = useState([]);//多测点查询表格列显示内容
    const [isHumi, setIsHumi] = useState(false);
    const [data, setData] = useState([])
    const [dataP, setDataP] = useState([])
    const [dataChart, setdataChart] = useState([])
    const [startTime, setStartTime] = useState('')//历史数据开始时间
    const [endTime, setEndTime] = useState('')
    const [isChangeTime,setIsChangeTime] = useState(false);
    const [dataF, setDataF] = useState({ tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 })
    const [seriesTempData,setSeriesTempData] = useState([]);
    const [tempChart,setTempChart] = useState(undefined);
    const [dataWainF, setDataWainF] = useState({ tl: 0, th: 0,  hl: 0, hh: 0 })
    const [isWaiting, setIsWaiting] = useState(false);
    const [showUnitName,setShowUnitName] = useState('')
    const [localCompany,setLocalCompany] = useState('');//本地公司名称
    const [userName,setUserName] = useState('');
    const [minInterval,setMinInterval] = useState(0);
    const [showUnit,setShowUnit] = useState('℃');
    const [showBound,setShowBound] = useState(false);
    const [showBoundWarnT,setShowBoundWarnT] = useState(false);
    const [showBoundWarnH,setShowBoundWarnH] = useState(false);
    const [recordCount,setRecordCount] = useState('');//记录条数
    const [tabKey,setTabKey] = useState("1")
    const [tableCurrent,setTableCurrent] = useState(1)
    const [tablePageSize,setTablePageSize] = useState(10)
    const [isExportHumi,setIsExportHumi] = useState(true);
    const [showHisModeNew,setShowHisModeNew] = useState(false)
    const [showHisLimit,setShowHisLimit] = useState(false)
    const [myChartP,setMyChartP] = useState()
    const [tableColums,setTableColums] = useState([])
    const { state_device, dispatch_device } = useContext(StateDeviceContext)
    const plotRef = useRef()
    const configtemp = {
        autoFit:true,
        data: dataChart,
        padding: 'auto',
        // padding:[40,8,60,80],
        xField: 'data_time',
        //height: 500,
        // yField: props.item.Type===209?'val':'temp',
        yField: 'temp',
        seriesField:'name',
        slider: {
            start: 0,
            end: 1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        connectNulls:false,
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    return ''.concat(v).replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
                        return ''.concat(s, ',');
                    })+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃');
                },
            },
            max:dataWainF.th>dataF.tmax?dataWainF.th+2:dataF.tmax+2,
            min:dataWainF.tl<dataF.tmin?dataWainF.tl-2:dataF.tmin-2,
        },
        xAxis: {
            label: {
                offset:20
            },

        },
        annotations:showBound?showBoundWarnT? [
            {
                type: 'line',
                start: ['start',dataWainF.th],
                end:['end',dataWainF.th],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.th],
                content: `${dataWainF.th+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.TempWarningHigh],
                end:['end',props.item.Sensor.TempWarningHigh],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.TempWarningHigh],
                content: `${props.item.Sensor.TempWarningHigh+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.tl],
                end:['end',dataWainF.tl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.tl],
                content: `${dataWainF.tl+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(下)`,
                offsetY: 18,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.TempWarningLow],
                end:['end',props.item.Sensor.TempWarningLow],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.TempWarningLow],
                content: `${props.item.Sensor.TempWarningLow+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(下)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[
            {
                type: 'line',
                start: ['start',dataWainF.th],
                end:['end',dataWainF.th],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.th],
                content: `${dataWainF.th+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.tl],
                end:['end',dataWainF.tl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.tl],
                content: `${dataWainF.tl+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(下)`,
                offsetY: 18,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[]
        ,
        legend: {
            position: 'top-left',
            items: [
                {
                    name: showUnitName,
                    marker: {
                      symbol: 'square',
                      style: {
                        fill: '#00bc12',
                      },
                    },
                },
            ],
        }, 
        color: ['#00bc12','#FFB6C1','#FFB6C1',],
    };
    const confighumi = {
        data: dataChart,
        autoFit:true,
        padding: 'auto',
        // padding:[16,8,16,200],
        xField: 'data_time',
        yField: 'humi',
        seriesField:'name',
        slider: {
            start: 0,
            end: 1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    
                    return ''.concat(v).replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
                        return ''.concat(s, ',');
                    });
                },
            },
            max:(dataWainF.hh>97||dataF.hmax>97)?100:dataWainF.hh>dataF.hmax?dataWainF.hh+2:dataF.hmax+2,
            min:(dataWainF.hl<3||dataF.hmin<3)?0:dataWainF.hl<dataF.hmin?dataWainF.hl-2:dataF.hmin-2,
        },
        xAxis: {
            label: {
                offset:20
            },

        },
        annotations:showBound?showBoundWarnH? [
            {
                type: 'line',
                start: ['start',dataWainF.hh],
                end:['end',dataWainF.hh],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hh],
                content: dataWainF.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.HumiWarningHigh],
                end:['end',props.item.Sensor.HumiWarningHigh],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.HumiWarningHigh],
                content: props.item.Sensor.HumiWarningHigh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.hl],
                end:['end',dataWainF.hl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hl],
                content: dataWainF.hl+'(下)',
                offsetY: 18,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.HumiWarningLow],
                end:['end',props.item.Sensor.HumiWarningLow],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.HumiWarningLow],
                content: props.item.Sensor.HumiWarningLow+'(下)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:
        [ 
            {
            type: 'line',
            start: ['start',dataWainF.hh],
            end:['end',dataWainF.hh],
            style: {
              stroke: '#F4664A',
              lineDash: [5, 4],
            },
        },
        {
            type: 'text',
            position: ['min', dataWainF.hh],
            content: dataWainF.hh+'(上)',
            offsetY: -4,
            offsetX: -18,
            style: {
              textBaseline: 'bottom',
            },
        },
        {
            type: 'line',
            start: ['start',dataWainF.hl],
            end:['end',dataWainF.hl],
            style: {
              stroke: '#F4664A',
              lineDash: [5, 4],
            },
        },
        {
            type: 'text',
            position: ['min', dataWainF.hl],
            content: dataWainF.hl+'(下)',
            offsetY: 18,
            offsetX: -18,
            style: {
              textBaseline: 'bottom',
            },
        },]:[],
        legend: {
            position: 'top-left',
            items: [
                {
                    name: '湿度',
                    marker: {
                      symbol: 'square',
                      style: {
                        fill: '#1979C9',
                      },
                    },
                },
            ],
          }, //
          color: ['#1979C9','#FFB6C1','#FFB6C1'],
    };
    const configtemps = {
        data: dataChart.filter(x=>x.node!==0),
        padding: 'auto',
        xField: 'data_time',
        autoFit:true,
        yField: 'temp',
        seriesField: 'name',
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    var i = v.indexOf('.');
                    return i===-1?v:v.slice(0,i+2);
                },
            },
            // tickCount:10
            max:dataWainF.th>dataF.tmax?dataWainF.th+2:dataF.tmax+2,
            min:dataWainF.tl<dataF.tmin?dataWainF.tl-2:dataF.tmin-2,
        },
        xAxis: {
            label: {
                offset:20
            },

        },
        slider: {
            start: 0,
            end:1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        annotations:showBound?showBoundWarnT? [
            {
                type: 'line',
                start: ['start',dataWainF.th],
                end:['end',dataWainF.th],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.th],
                content: `${dataWainF.th+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.TempWarningHigh],
                end:['end',props.item.Sensor.TempWarningHigh],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.TempWarningHigh],
                content: `${props.item.Sensor.TempWarningHigh+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.tl],
                end:['end',dataWainF.tl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.tl],
                content: `${dataWainF.tl+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(下)`,
                offsetY: 18,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.TempWarningLow],
                end:['end',props.item.Sensor.TempWarningLow],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.TempWarningLow],
                content: `${props.item.Sensor.TempWarningLow+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(下)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[
            {
                type: 'line',
                start: ['start',dataWainF.th],
                end:['end',dataWainF.th],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.th],
                content: `${dataWainF.th+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.tl],
                end:['end',dataWainF.tl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.tl],
                content: `${dataWainF.tl+(props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃')}(下)`,
                offsetY: 18,
                offsetX:-18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[]
        ,
        // color: '#D62A0D',
        color: ['#00bc12','#D62A0D', '#9900FF', '#000000','#335541','#656485','#784512','#255454','#621532','#785423','#996655','#996699','#9999CC','#99CC99','#99FFFF'],
    };
    const confighumis = {
        data: dataChart.filter(x=>x.node!==0),
        padding: 'auto',
        xField: 'data_time',
        autoFit:true,
        yField: 'humi',
        seriesField: 'name',
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    var i = v.indexOf('.');
                    return i===-1?v:v.slice(0,i+2);
                },
            },
            // tickCount:10
            max:(dataWainF.hh>97||dataF.hmax>97)?100:dataWainF.hh>dataF.hmax?dataWainF.hh+2:dataF.hmax+2,
            min:(dataWainF.hl<3||dataF.hmin<3)?0:dataWainF.hl<dataF.hmin?dataWainF.hl-2:dataF.hmin-2,
        },
        xAxis: {
            label: {
                offset:20
            },

        },
        slider: {
            start: 0,
            end:1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        annotations:showBound?showBoundWarnH? [
            {
                type: 'line',
                start: ['start',dataWainF.hh],
                end:['end',dataWainF.hh],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hh],
                content: dataWainF.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.HumiWarningHigh],
                end:['end',props.item.Sensor.HumiWarningHigh],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.HumiWarningHigh],
                content: props.item.Sensor.HumiWarningHigh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.hl],
                end:['end',dataWainF.hl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hl],
                content: dataWainF.hl+'(下)',
                offsetY: 18,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',props.item.Sensor.HumiWarningLow],
                end:['end',props.item.Sensor.HumiWarningLow],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', props.item.Sensor.HumiWarningLow],
                content: props.item.Sensor.HumiWarningLow+'(下)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:
        [ 
            {
            type: 'line',
            start: ['start',dataWainF.hh],
            end:['end',dataWainF.hh],
            style: {
              stroke: '#F4664A',
              lineDash: [5, 4],
            },
        },
        {
            type: 'text',
            position: ['min', dataWainF.hh],
            content: dataWainF.hh+'(上)',
            offsetY: -4,
            offsetX: -18,
            style: {
              textBaseline: 'bottom',
            },
        },
        {
            type: 'line',
            start: ['start',dataWainF.hl],
            end:['end',dataWainF.hl],
            style: {
              stroke: '#F4664A',
              lineDash: [5, 4],
            },
        },
        {
            type: 'text',
            position: ['min', dataWainF.hl],
            content: dataWainF.hl+'(下)',
            offsetY: 18,
            offsetX: -18,
            style: {
              textBaseline: 'bottom',
            },
        },]:[],
    };
    const option = {
        tooltip: {
            trigger: 'axis',
        },
        title: {
            left: 'center',
            text:isHumi?`${userName}\n${startTime}-${endTime}曲线图 \n ${showUnitName}最小值${dataF.tmin}${showUnitName}最大值${dataF.tmax}湿度最小值${dataF.hmin}湿度最大值${dataF.hmax}`:`${userName}\n${startTime}-${endTime}曲线图 \n ${showUnitName}最小值${dataF.tmin}${showUnitName}最大值${dataF.tmax}`
          },
        legend:{
            top:80,
            type:'scroll',
        },
        xAxis: {
            type: 'time',
            axisLabel:{
                formatter:`{HH}:{mm}:{ss}\n{yyyy}-{MM}-{dd} `
            },
            min:startTime,
            max:endTime
        },
        yAxis: {
            type: 'value',

            min: function (value) {
                return value.min.toFixed(1) - 2;
            },
            max : function (value) {
                return value.max.toFixed(1) +2;
            },      
            axisLabel:{
                formatter:function (value, index) {
                    return value.toFixed(1) ;
                }
            }
        },
        grid:
        {
            left:50,
            rigeht:0,
            bottom:0,
            top:120,
            containLabel:true
        },
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     start: 0,
        //     end: 100
        //   },
        // ],
        series: seriesTempData,
    };
    
    const columnsLeft = [
        {
            title:'记录条数:'+recordCount,
            children:[
                {
                    title: '时间',
                    dataIndex: 'data_time',
                    key: 'id',
                    align: 'center  ',
                    width: 160,
                    fixed: true,
                    sorter: (a, b) =>new Date(a.data_time).getTime()  -new Date(b.data_time).getTime() ,
                }
            ]

        },
    ];
    const columnsRight = [

        {
            title: '信号',
            dataIndex: 'csq',
            align: 'center',
            width: 80,
        },
        {
            title: '电源',
            dataIndex: props.item.Type===208?'power0':'power',
            align: 'center',
            width: 80,
            render: (text, record) => (
                <div>{text === 0 ? "正常" :text === 1? "电池":''}</div>
            )
        },
        {
            title: '电量',
            dataIndex: props.item.Type===208?'battery0':'battery',
            align: 'center',
            width: 80,
        },
    ];

     // 单测点查询历史数据
     const getHistory = (starttime, endtime,unitName,newmodel=false,showLimit=false) => {
        setIsWaiting(true)
        setRecordCount('');
        setShowBound(true)
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setDataWainF({th:0,tl:0,hh:0,hl:0});
        setdataChart([]);
        setData([]);
        let dataStatistics={tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 };
        setTimeout(() => {

            http.get("/v1/history?device=" + props.item.Sn + "&node=" + props.item.Node + "&starttime=" + starttime + "&endtime=" + endtime+"&min="+minInterval, {})
                .then(data => {
                    setIsWaiting(false)
                    setIsHumi(false);
                    let is_Humi = false;
                    if (data.code === 0) {
                        if (data.data===null||data.data.length === 0) return message.warning('暂无数据');
                        let checkData = data.data[0];
                        if(checkData.node===0){
                            checkData= data.data[1];
                        }
                        if(checkData.humi_switch!==0&&checkData.humi_enable!==0){
                            setIsHumi(true);
                            is_Humi = true;
                        }
                        let dataF =((newmodel||showHisModeNew)&&(props.item.Type===201||props.item.Type===212||props.item.Type===208))?data.data.filter(x=>(+x.data_time.slice(-5,-3)%30===0)||x.temp>x.temp_h||x.temp<x.temp_l||x.humi>x.humi_h||x.humi<x.humi_l):data.data
                        var artemp= dataF.filter(item => item.temp !== 102.3 && item.temp !== 102.2 &&item.temp_switch!==0&&item.temp !== -102.3 && item.temp !== -102.2);
                        if(is_Humi){
                            artemp= artemp.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2);
                        }
                        let ar = JSON.parse(JSON.stringify(artemp));
                        var arLen = ar.length;
                        setDataP(JSON.parse(JSON.stringify(dataF)))
                        setData(dataF.reverse());
                        setRecordCount(dataF.length+'');
                        
                        if(props.item.Node>0) {
                            if (arLen === 0 ) return message.warning('暂无有效数据');
                            let tmax =ar.map(o=>o.temp).reduce((a,b)=>Math.max(a,b));
                            let tmin = ar.map(o=>o.temp).reduce((a,b)=>Math.min(a,b));
                            let hmax =ar.map(o=>o.humi).reduce((a,b)=>Math.max(a,b)); 
                            let hmin = ar.map(o=>o.humi).reduce((a,b)=>Math.min(a,b)); 
                            let tavg = 0, havg = 0;
                            ar.map(item => {
                                tavg = tavg + item.temp
                                havg = havg + item.humi
                            })
                            tavg = tavg / arLen
                            havg = havg / arLen
                            setDataF({ tmax, tmin, tavg, hmin, hmax, havg });
                            dataStatistics = {
                                tmax: tmax,
                                tmin: tmin,
                                tavg: tavg,
                                hmax: hmax,
                                hmin: hmin,
                                havg: havg
                            }
                            let tH = props.item.Sensor.TempAlarmHigh;
                            let tL = props.item.Sensor.TempAlarmLow;
                            let hH = props.item.Sensor.HumiAlarmHigh;
                            let hL = props.item.Sensor.HumiAlarmLow;
                            if(props.item.Sensor.Hide===2||props.item.Sensor.Hide===3){
                                setShowBound(false)
                                setDataWainF({th:dataStatistics.tmax,tl:dataStatistics.tmin,hh:dataStatistics.hmax,hl:dataStatistics.hmin});
                            }else{
                                setDataWainF({th:tH,tl:tL,hh:hH,hl:hL});
                            }
                            let maxNum = ar.length;
                            let normalData = [];
                            let warnData=[];
                            let start ;let end;
                            let seriesData=[]
                            let tempdata =[];
                            let humidata =[];
                            let name ='';
                            ar.map(val=>{
                                tempdata.push([val.data_time,val.temp]);
                                humidata.push([val.data_time,val.humi]);
                                if(name==='' ){
                                    name =val.name
                                }
                            })
                            ar[0].data_time!==startTime&&tempdata.unshift(null);
                            ar[ar.length-1].data_time!==endTime&&tempdata.push(null);
                            seriesData.push({
                                name:name+(unitName?unitName:showUnitName)+'曲线',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                data: tempdata,
                            })
                            is_Humi&&seriesData.push({
                                name:name+'湿度曲线',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                data: humidata,
                            })
                            setSeriesTempData(seriesData);
                            if(maxNum<20000){
                                warnData=ar;
                            }
                            if(maxNum>20000&&maxNum<=50000){
                                ar.map(m=>{
                                    if(m.temp_alarm===1||m.humi_alarm===1){
                                        warnData.push(m)
                                    }else{
                                        normalData.push(m)
                                    }
                                })
                                normalData.map((m,i)=>{
                                    i%2==0&&warnData.push(m);
                                })
                                warnData.sort((a,b)=>a.data_time>b.data_time);
                            }
                            if(maxNum>50000&&maxNum<=100000){
                                ar.map(m=>{
                                    if(m.temp_alarm===1||m.humi_alarm===1){
                                        warnData.push(m)
                                    }else{
                                        normalData.push(m)
                                    }
                                })
                                normalData.map((m,i)=>{
                                    i%3==0&&warnData.push(m);
                                })
                                warnData.sort((a,b)=>a.data_time>b.data_time);
                                
                            }
                            if(maxNum>100000&&maxNum<=200000){
                                ar.map(m=>{
                                    if(m.temp_alarm===1||m.humi_alarm===1){
                                        warnData.push(m)
                                    }else{
                                        normalData.push(m)
                                    }
                                })
                                normalData.map((m,i)=>{
                                    i%6==0&&warnData.push(m);
                                })
                                warnData.sort((a,b)=>a.data_time>b.data_time);
                            }
                            if(maxNum>200000){
                                ar.map(m=>{
                                    if(m.temp_alarm===1||m.humi_alarm===1){
                                        warnData.push(m)
                                    }else{
                                        normalData.push(m)
                                    }
                                })
                                normalData.map((m,i)=>{
                                    i%10==0&&warnData.push(m);
                                })
                                warnData.sort((a,b)=>a.data_time>b.data_time);
                            }
                            start =  warnData[0];
                            end = warnData[warnData.length-1];
                            start.data_time!==starttime&&warnData.unshift({data_time:starttime,temp:null});
                            end.data_time!==endtime&&warnData.push({data_time:endtime,temp:null});
                            setdataChart(warnData);
                            
                        }
                        let columns = [
                            {
                                title:'记录条数:'+dataF.length+'',
                                children:[
                                    {
                                        title: '时间',
                                        dataIndex: 'data_time',
                                        align: 'center',
                                        sorter: (a, b) =>new Date(a.data_time).getTime()  -new Date(b.data_time).getTime() ,
                                    }
                                ]
                                
                            },
                        ];
                        if(props.item.Node===0){
                            props.item.Sensor.Door===1&&
                            columns.push(
                                {
                                    title: '开关门',
                                    dataIndex: 'door',
                                    align: 'center',
                                    render: (text, record) => 
                                        <div>
                                            <div>{record.door===0?'关门':'开门'}</div>
                                        </div>
                                }
                            )
                        }else{
                            columns.push(
                                {
                                    title:showUnitName+`  (最大:${props.item.Type===211?dataStatistics.tmax.toFixed(2):dataStatistics.tmax.toFixed(1)} 
                                    最小:${props.item.Type===211?dataStatistics.tmin.toFixed(2):dataStatistics.tmin.toFixed(1)} 
                                    平均:${dataStatistics.tavg.toFixed(1)})`,
                                    children:[
                                        {
                                            title: `记录值(${showUnit})`,
                                            align: 'center',
                                            render: (text, record) => (
                                               <span style={{color:record.temp_alarm === 1 ?'red':''}}>{record.temp_switch===0?'--':
                                                    (record.temp===102.2||record.temp===102.3||record.temp===-102.2||record.temp===-102.3)?'NL':record.type===211?record.temp.toFixed(2):record.temp.toFixed(1)}</span>
                                            ),
                                        },
                                        {
                                            title: '状态',
                                            align: 'center',
                                            render: (text, record) => (
                                                <div style={{color:record.temp_alarm === 1 ?'red':''}}>{record.temp_switch===0?'停用':record.temp_alarm === 1 ? '报警' : '正常'}</div>
                                            ),

                                        },
                                    ],
                                }
                            )
                            if(props.item.Humi===1){
                                columns.push(
                                    {
                                        title:'湿度'+`  (最大:${dataStatistics.hmax.toFixed(1)} 
                                        最小:${dataStatistics.hmin.toFixed(1)} 
                                        平均:${dataStatistics.havg.toFixed(1)})`,
                                        children:[
                
                                            {
                                                title:'记录值(%RH)',
                                                align: 'center',
                                                render: (text, record) => 
                                                    <div style={{color:record.humi_alarm === 1 ?'red':''}}>{record.humi_switch===0?'--':
                                                        (record.humi===102.2||record.humi===102.3||record.humi===-102.2||record.humi===-102.3)?'NL':record.humi.toFixed(1)}</div>                           
                                            },
                                            
                                            {
                                                title:'状态',
                                                align: 'center',
                                                render: (text, record) => 
                                                    <div style={{color:record.humi_alarm === 1 ?'red':''}}>{record.humi_switch===0?'停用':record.humi_alarm === 1 ? '报警' :record['humi_alarm'] === 0 ? '正常':null}</div>
                                            },
                                        ],
                                    },
                                )
                            }
                            if(showHisLimit||showLimit){
                                columns[1].children.unshift(
                                    {
                                        title:`上下限(${showUnit})`,
                                        align: 'center',
                                        render: (text, record) => (
                                            <div>
                                                {
                                                    `${record['temp_h']}~${record['temp_l']}`
                                                }
                                            </div>
                                        )
                                    },
                                )
                                if(props.item.Humi===1){
                                    columns[2].children.unshift(
                                        {
                                            title:'上下限(%RH)',
                                            align: 'center',
                                            render: (text, record) => 
                                                <div>{record.humi_h+'~'+record.humi_l}</div>,
                                        },
                                    )
                                }
                                
                            }
                        }
                        if(props.item.Type!==214){
                            columns.push(
                                {
                                    title: '信号',
                                    dataIndex: 'csq',
                                    align: 'center',
                                },
                            )
                        }
                        columns.push(
                            {
                                title: props.item.Type===214?'门状态':'电源',
                                dataIndex:  props.item.Type===214?'door':'power',
                                align: 'center',
                                render:(text,record)=>(
                                    props.item.Type===214?
                                    <div style={{color:text===1?'red':'black'}}>{record.door === 0?"门关闭":"门开启"}</div>
                                    :
                                    <div>{record.power === 0?"正常":"电池"}</div>
                                )
                            },
                            {
                                title: '电量',
                                dataIndex: 'battery',
                                align: 'center',
                            }
                        )
                        setTableColums(columns)
                        
                    }
            })
            
        }, 500);

    };
     // 单测点查询历史数据json
     const getHistoryJson = (starttime, endtime,unitName) => {
        setShowBound(true)
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setDataWainF({th:0,tl:0,hh:0,hl:0});
        setdataChart([]);
        setData([]);
        setTimeout(() => {
            http.get("/v1/history?device=" + props.item.Sn + "&node=" + props.item.Node + "&starttime=" + starttime + "&endtime=" + endtime+"&min="+minInterval, {})
            .then(data => {
                setIsWaiting(false)
                setIsHumi(false);
                if (data.code === 0) {
                    if (data.data===null||data.data.length === 0) return message.warning('暂无数据'); 
                    let tempData =[];
                    data.data.map(item=>{
                        if(item.json_data.Valid){
                            item.sensorDatas=JSON.parse(item.json_data.String)[0];
                            item.val = item.sensorDatas.value;
                        }else{
                            item.sensorDatas=null;
                        }
                        tempData.push(item);
                    })
                    let filteData = tempData.filter(item => item.val !== 102.3 && item.val !== 102.2 &&item.sensorDatas.enable!==0);
                    setData(tempData.reverse())
                    var tavg = 0
                    var tmax = -100
                    var tmin = 100
                    var havg = 0
                    var hmax = 0
                    var hmin = 100
                    filteData.map(item => {
                        let value = item.sensorDatas.value;
                        if (value > tmax) {
                            tmax = value
                        }
                        if (value < tmin) {
                            tmin = value
                        }
                        tavg = tavg + value
                    })
                    tavg = tavg / filteData.length
                    setDataF({ tmax, tmin, tavg, hmin, hmax, havg });
                    let tH = filteData[0].sensorDatas.high;
                    let tL = filteData[0].sensorDatas.low;
                    setDataWainF({th:tH,tl:tL});
                    let start ;let end;
                    let seriesData=[]
                    let timedata =[];
                    let antvData =[];
                    let name ='';
                    //时间轴曲线
                    filteData.map(val=>{
                        timedata.push([val.data_time,val.sensorDatas.value]);
                        antvData.push(val);
                        if(name==='' ){
                            name =val.name
                        }
                    })
                    filteData[0].data_time!==startTime&&timedata.unshift(null);
                    filteData[filteData.length-1].data_time!==endTime&&timedata.push(null);
                    seriesData.push({
                        name:name+(unitName?unitName:showUnitName)+'曲线',
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        data: timedata,
                    })
                    setSeriesTempData(seriesData);
                    //antv曲线
                    start =  antvData[0];
                    end = antvData[antvData.length-1];
                    start.data_time!==starttime&&antvData.unshift({data_time:starttime,val:null});
                    end.data_time!==endtime&&antvData.push({data_time:endtime,val:null});
                    setdataChart(antvData);
                }
            })
        }, 500);

    };
    // 多测点查询历史数据
    const getHistorys = (nodes,starttime, endtime,unitName,selDevNodes,newmodel=false,showLimit=false)=>{
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        setRecordCount('');
        // setTimeout(() => {
            if (nodes.length===0) {
                setIsWaiting(false);
                return message.warning('未选择设备')
            }
            props.item.Type===208&&nodes.push(0);
            let url = "/v1";   
            url += "/history?device=" + props.item.Sn + "&node=" + nodes + "&starttime=" ;
            url+=starttime+"&endtime=" + endtime;
            url+="&min="+minInterval;
            setIsWaiting(true);
            setIsHumi(false);
            http.get(url,{}).then((data) => {
                setIsWaiting(false);
                setDataWainF({th:0,tl:0,hh:0,hl:0});
                if (data.code === 0) {
                    if (data.data===null||data.data.length === 0) return message.warning('暂无数据');
                    let is_Humi=false;
                    let sss= data.data.find(x=>x.humi_switch!==0&&x.humi_enable!==0);//查找是否有湿度数据
                    if(sss){
                        setIsHumi(true);
                        is_Humi= true;
                    }
                    let baseData=[];
                    let selType = state.device.filter(x=>x.sn===props.item.Sn)[0].type
                    let dataF =((newmodel||showHisModeNew)&&(selType===201||selType===212||selType===208))?data.data.filter(x=>(+x.data_time.slice(-5,-3)%30===0)||x.temp>x.temp_h||x.temp<x.temp_l||x.humi>x.humi_h||x.humi<x.humi_l):data.data
                    const timeMap = new Map(baseData.map(x => [x.data_time, x]));
                    dataF.forEach(m => {
                        // 通过哈希表快速定位 (替代find)
                        const existing = timeMap.get(m.data_time);
                        if (existing) {
                            // 批量赋值代替逐属性修改
                            const nodeSuffix = m.node;
                            const fields = {
                                temp: m.temp,
                                temp_h: m.temp_h,
                                temp_l: m.temp_l,
                                temp_alarm: m.temp_alarm,
                                temp_switch: m.temp_switch,
                                humi: m.humi,
                                humi_h: m.humi_h,
                                humi_l: m.humi_l,
                                humi_alarm: m.humi_alarm,
                                humi_switch: m.humi_switch,
                                humi_enable: m.humi_enable,
                                districtname: m.districtname,
                                door: m.door,
                                power: m.power,
                                battery: m.battery
                            };
    
                            Object.entries(fields).forEach(([key, val]) => {
                                existing[`${key}${nodeSuffix}`] = val;
                            });
                        } else {
                            // 创建新对象时一次性构建所有属性
                            const newNode = { data_time: m.data_time };
                            const nodeSuffix = m.node;
    
                            [
                                ['temp', m.temp],
                                ['temp_h', m.temp_h],
                                ['temp_l', m.temp_l],
                                ['temp_alarm', m.temp_alarm],
                                ['temp_switch', m.temp_switch],
                                ['humi', m.humi],
                                ['humi_h', m.humi_h],
                                ['humi_l', m.humi_l],
                                ['humi_alarm', m.humi_alarm],
                                ['humi_switch', m.humi_switch],
                                ['humi_enable', m.humi_enable],
                                ['districtname', m.districtname],
                                ['door', m.door],
                                ['power', m.power],
                                ['battery', m.battery]
                            ].forEach(([key, val]) => {
                                newNode[`${key}${nodeSuffix}`] = val;
                            });
                            newNode.csq = m.csq;
                            newNode.power = m.power;
                            newNode.battery = m.battery;
                            timeMap.set(m.data_time, newNode);
                            baseData.push(newNode);
                        }
                    });
                    // dataF.map(m=>{
                    //     let index = baseData.findIndex(x=>x.data_time===m.data_time);
                    //     if(index!==-1){
                    //         baseData[index]['temp' + m.node] = m.temp
                    //         baseData[index]['temp_h' + m.node] = m.temp_h
                    //         baseData[index]['temp_l' + m.node] = m.temp_l
                    //         baseData[index]['temp_alarm' + m.node] = m.temp_alarm
                    //         baseData[index]['temp_switch' + m.node] = m.temp_switch
                    //         baseData[index]['humi' + m.node] = m.humi
                    //         baseData[index]['humi_h' + m.node] = m.humi_h
                    //         baseData[index]['humi_l' + m.node] = m.humi_l
                    //         baseData[index]['humi_alarm' + m.node] = m.humi_alarm
                    //         baseData[index]['humi_switch' + m.node] = m.humi_switch
                    //         baseData[index]['humi_enable' + m.node] = m.humi_enable
                    //         baseData[index]['districtname' + m.node] = m.districtname
                    //         baseData[index]['door' + m.node] = m.door
                    //         baseData[index]['power' + m.node] = m.power
                    //         baseData[index]['battery' + m.node] = m.battery
                    //     }else{
                    //         m['temp' + m.node] = m.temp
                    //         m['temp_h' + m.node] = m.temp_h
                    //         m['temp_l' + m.node] = m.temp_l
                    //         m['temp_alarm' + m.node] = m.temp_alarm
                    //         m['temp_switch' + m.node] = m.temp_switch
                    //         m['humi' + m.node] = m.humi
                    //         m['humi_h' + m.node] = m.humi_h
                    //         m['humi_l' + m.node] = m.humi_l
                    //         m['humi_alarm' + m.node] = m.humi_alarm
                    //         m['humi_switch' + m.node] = m.humi_switch
                    //         m['humi_enable' + m.node] = m.humi_enable
                    //         m['districtname' + m.node] = m.districtname
                    //         m['door' + m.node] = m.door
                    //         m['power' + m.node] = m.power
                    //         m['battery' + m.node] = m.battery
                    //         baseData.push(m)
                    //     }
                    // })
                    setData(baseData.reverse());
                    setRecordCount(baseData.length+'');
                    var ar = dataF.filter(item => item.temp !== 102.3 && item.temp !== 102.2 &&item.temp_switch!==0&&item.temp !== -102.3 && item.temp !== -102.2);
                    if(is_Humi){
                        ar = ar.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2&&item.humi_switch!==0&&item.humi_enable!==0);
                    }
                    if (ar.length === 0) return message.warning('暂无有效数据');
                    ar.sort((a,b)=>a.node-b.node);
                    let dev_val=[];
                    if(nodes.length>0){
                        var tavg = 0;
                        var havg = 0;
                        let isShowBound = true
                        let tmax =ar.map(o=>o.temp).reduce((a,b)=>Math.max(a,b));
                        let tmin = ar.map(o=>o.temp).reduce((a,b)=>Math.min(a,b));
                        let hmax =ar.map(o=>o.humi).reduce((a,b)=>Math.max(a,b)); 
                        let hmin = ar.map(o=>o.humi).reduce((a,b)=>Math.min(a,b)); 
                        let isHumi =  ar[0].humi_enable&&ar[0].humi_switch;
                        ar.map(item => {
                            if(isShowBound){
                                if(item.temp_h!==ar[0].temp_h||item.temp_l!==ar[0].temp_l){
                                    isShowBound = false
                                }else{
                                    if(isHumi&&(item.humi_h!==ar[0].humi_h||item.humi_l!==ar[0].humi_l)){
                                        isShowBound = false
                                    }
                                }
                            }
                            if(dev_val.length===0){
                                dev_val.push({node:item.node,temp_h:item.temp,temp_l:item.temp,humi_l:item.humi,humi_h:item.humi,temp_s:item.temp,humi_s:item.humi,count:1})
                            }else{
                                let b= dev_val.findIndex(x=>x.node===item.node);
                                if(b===-1){
                                    dev_val.push({node:item.node,temp_h:item.temp,temp_l:item.temp,humi_l:item.humi,humi_h:item.humi,temp_s:item.temp,humi_s:item.humi,count:1})
                                }else{
                                    dev_val[b].temp_s +=item.temp; 
                                    dev_val[b].humi_s +=item.humi; 
                                    dev_val[b].count +=1; 
                                    if(item.temp>dev_val[b].temp_h){
                                        dev_val[b].temp_h = item.temp
                                    }
                                    if(item.temp<dev_val[b].temp_l){
                                        dev_val[b].temp_l = item.temp
                                    }
                                    if(item.humi>dev_val[b].humi_h){
                                        dev_val[b].humi_h = item.humi
                                    }
                                    if(item.humi<dev_val[b].humi_l){
                                        dev_val[b].humi_l = item.humi
                                    }
                                }
                            }
                            tavg = tavg + item.temp;
                            havg = havg + item.humi;
                        })
                        tavg = tavg / ar.length;
                        havg = havg / ar.length;
                        setDataF({ tmax, tmin, tavg, hmin, hmax, havg });
                        setShowBound(isShowBound)
                        dev_val.map(item=>{
                            item.temp_s = item.temp_s/item.count
                            item.humi_s = item.humi_s/item.count
                        })
                    }
                    if(selNode.length===1){
                        if(props.item.Sensor.Hide===2||props.item.Sensor.Hide===3){
                            setShowBound(false)
                        }
                    }
                    setDataWainF({th:ar[0].temp_h,tl:ar[0].temp_l,hh:ar[0].humi_h,hl:ar[0].humi_l});
                    let start =  dataF[0];
                    let end = dataF[dataF.length-1];
                    start.data_time!==starttime&&ar.unshift({data_time:starttime,temp:null});
                    end.data_time!==endtime&&ar.push({data_time:endtime,temp:null});
                    setdataChart(ar);
                    let seriesData=[]
                    nodes.map(item=>{
                        let tempdata =[];
                        let humidata =[];
                        let name ='';
                        ar.filter(x=>x.node ==item).map(val=>{
                            tempdata.push([val.data_time,val.temp]);
                            humidata.push([val.data_time,val.humi]);
                            if(name==='' ){
                                name =val.name
                            }
                        })
                        start.data_time!==starttime&&tempdata.unshift(null);
                        start.data_time!==starttime&&humidata.unshift(null);
                        end.data_time!==endtime&&tempdata.push(null);
                        end.data_time!==endtime&&humidata.push(null);
                        if(name!==''){
                            seriesData.push({
                                'name':name+(unitName?unitName:showUnitName)+'曲线',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                data: tempdata,
                            })
                            is_Humi&&seriesData.push({
                                'name':name+'湿度曲线',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                data: humidata,
                            })
                        }
                    })
                    setSeriesTempData(seriesData);
                    let sd = selDevNodes
                    var nodeCol = new Array();
                    if(sd.length>1){
                        sd.sort((a,b)=>a.node-b.node);
                        if(sd[0].node===0){
                            let temp = sd.splice(0,1);
                            sd.push(temp[0]);
                        }
                    }
                    sd.map(({ node, name, district_name, m_name,id,door_alarm ,type,humi}) => {
                        let devNode= dev_val.filter(x=>x.node===node);
                        // nodes.push(node);
                        var t = 'temp' + node;
                        // 断电 开关门
                        if(node===0){
                            door_alarm===1&&
                            nodeCol.push({
                                title: `${name}-(区域:${district_name}-主机:${m_name}-测点ID:${node})`,
                                align: 'center',
                                children: [
                                    {
                                        title: '开关门',
                                        dataIndex: 'door' + node,
                                        width: 300,
                                        align: 'center',
                                        render: (text, record) => (
                                            <div>
                                                <div>{record['door' + node]  === 0 ? "关门" : '开门'}</div>
                                            </div>
                                        )
                                    },
                                    
                                ]
                            })
                        }else{//温湿度
                            let obj = {
                                title: `${name}-(区域:${district_name}-主机:${m_name}-测点ID:${node})`,
                                align: 'center',
                                children:[
                                {
                                        title:`${(type===205||type===210||type===211)?'压强':'温度'}  (最大:${devNode.length>0&&devNode[0].temp_h.toFixed(1)} 
                                        最小:${devNode.length>0&&devNode[0].temp_l.toFixed(1)} 
                                        平均:${devNode.length>0&&devNode[0].temp_s.toFixed(1)})`,
                                        align:'center',
                                        children: [
                                            {
                                                title: type===205?'压强(Pa)':(type===210||type===211)?'压强(MPa)':'温度(℃)',
                                                dataIndex: 'temp' + node,
                                                key: 'temp' + id,
                                                align: 'center',
                                                width:100,
                                                render: (text, record) => (
                                                    <div>
                                                        <div style={{color:record['temp_alarm' + node] === 1 ?'red':''}}>{ record['temp_switch' + node] === 0 ? "--" : record?.['temp' + node]!==undefined?
                                                        (record['temp' + node] === 102.2||record['temp' + node] === 102.3||record['temp' + node] === -102.2||record['temp' + node] === -102.3)? " NL" :type===211?record['temp' + node].toFixed(2):record['temp' + node].toFixed(1):''}</div>
                                                    </div>
                                                )
                                            },
                                            {
                                                title: '状态',
                                                dataIndex: 'temp_alarm' + node,
                                                key: 'temp_alarm' + id,
                                                align: 'center',
                                                width: 60,
                                                render: (text, record) => (
                                                    <div style={{color:record['temp_alarm' + node] === 1 ?'red':''}}>{record['temp_switch' + node] === 0 ? "--" :record['temp_alarm' + node] === 0 ? '正常' :record['temp_alarm' + node] === 1? '报警':''}</div>
                                                )
                                            },
                                        ]
                                }
                                ]
                            }
                            if(showHisLimit||showLimit){
                                obj.children[0].children.unshift(
                                    {
                                        title: type===205?'上下限(Pa)':(type===210||type===211)?'上下限(MPa)':'上下限(℃)',
                                        align: 'center',
                                        width:100,
                                        render: (text, record) => (
                                            <div>
                                                {record['temp_switch' + node] === 0 ? null :record?.['temp_h' + node]===undefined?'': `${record['temp_h' + node]}~${record['temp_l' + node]}`}
                                            </div>
                                        )
                                    },
                                )
                            }
                            if(humi===1){
                                obj.children.push({
                                    title: `湿度 (最大:${devNode.length>0&&devNode[0].humi_h.toFixed(1)} 
                                        最小:${devNode.length>0&&devNode[0].humi_l.toFixed(1)} 
                                        平均:${devNode.length>0&&devNode[0].humi_s.toFixed(1)})`,
                                    align: 'center',
                                    children:[
                                        {
                                            title: '湿度(%RH)',
                                            dataIndex: 'humi' + node,
                                            align: 'center',
                                            width: 100,
                                            render: (text, record) => (
                                                <div>
                                                    <div style={{color:record['humi_alarm' + node] === 1 ?'red':''}}>{ record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--":record?.['humi' + node]!==undefined?
                                                    (record['humi' + node] === 102.2||record['humi' + node] === 102.3||record['humi' + node] === -102.2||record['humi' + node] === -102.3 )? " NL" : record['humi' + node].toFixed(1):''}</div>
                                                </div>
                                            )
                                        },
                                        {
                                            title: '状态',
                                            dataIndex: 'humi_alarm' + node,
                                            width: 60,
                                            align: 'center',
                                            render: (text, record) => (
                                                <div style={{color:record['humi_alarm' + node] === 1 ?'red':''}}>{record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--" :record['humi_alarm' + node] === 0 ? '正常' : record['humi_alarm' + node] === 1 ? '报警':''}</div>
                                            )
                                        },
                                    ]
                                })
                                if(showHisLimit||showLimit){
                                    obj.children[1].children.unshift(
                                        {
                                            title: '上下限(%RH)',
                                            // dataIndex: 'humi_h' + node,
                                            align: 'center',
                                            width: 100,
                                            render: (text, record) => (
                                                <div>
                                                    {record['humi_switch' + node] === 0 || record['humi_enable' + node]===0 ? null :record['humi_h' + node]? <div>{`${record['humi_h' + node]}~${record['humi_l' + node]}`}</div>:''}
                                                </div>
                                            )
                                        },
                                    )
                                }
                            }
                            if(type===214){
                                obj.children.push( {
                                    title: '门状态',
                                    align: 'center',
                                    dataIndex:'door'+node,
                                    width:80,
                                    render:(text,record)=>{
                                        return <div style={{color:text===1?'red':'black'}}>{text===1?'门开启':text===0?'门关闭':''}</div>
                                    }
                                })
                            }
                            if(type===214||type===208){
                                obj.children.push( 
                                {
                                    title: '电量',
                                    align: 'center',
                                    width:60,
                                    dataIndex:'battery'+node
                                }
                            )}
                            nodeCol.push(obj)
                        }
                        
                    })
                    setSelNodeColums(nodeCol);
                }
            })
        // }, 200);
        
    }
    const onChange_Tab = key => {
        setTabKey(key)
        if (key==='2'){
            setTimeout(() => {
                let chartDom = document.getElementById('tempEcharts');
                if(chartDom){
                    let myChart = echarts.init(chartDom);
                    setMyChartP(myChart)
                    option && myChart.setOption(option);
                    myChart.resize();
                    myChart&&setTempChart(myChart);
                    myChart&&myChart.dispatchAction({
                        type: 'legendScroll',
                        scrollDataIndex: 5,
                        // legendId: string
                    })

                }    
            }, 500);
            
        }else{
            tempChart&&tempChart.dispose();
        }
    };
    const onChange_Table = (page,pageSize) =>{
        setTableCurrent(page)
        setTablePageSize(pageSize)
    }
    // 要历史查询设备的所有测点设置全选
    const onCheckAllChange = e => {
        setCheckedList(e.target.checked ?  showSelDevNodesValue: []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
        setSelDevNodes(e.target.checked ?  showSelDevNodes: [])
        let nodes = [];
        showSelDevNodes.map(({ node}) => {
            nodes.push(node);
        })
        setSelNode(nodes);
    };
    const onCheckChange = list=>{
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < showSelDevNodes.length);
        setCheckAll(list.length === showSelDevNodes.length);
        let nodes = [];
        let sd = showSelDevNodes.filter(x=>list.indexOf(x.value)>-1);
        setSelDevNodes(sd)
        sd.map(({ node}) => {
            nodes.push(node);
        })
        setSelNode(nodes);
    }
    // 历史数据 保存为图片
    const saveImage = () => {
        setIsWaiting(true);
        var canvas2 = document.createElement("canvas");
        let _canvas = document.getElementById('devicechart');
        var w = parseInt(window.getComputedStyle(_canvas).width);
        var h = parseInt(window.getComputedStyle(_canvas).height);
        canvas2.width = w ;
        canvas2.height = h ;
        var context = canvas2.getContext("2d");
        context.scale(1, 1);
        html2canvas(document.getElementById('devicechart'), { canvas: canvas2 }).then((canvas) => {
            // canvas.style.width = (w + 40) + "px";
            // canvas.style.height = (h + 40) + "px";
            canvas.id = 'cutimg'
            var url = canvas.toDataURL('image/png');
            if(window.CefSharp!==undefined){
                window.CefSharp.BindObjectAsync("bound");
                window.bound.exportImg(url);
     
            }else{
                var downloadLink = document.createElement("a");
                downloadLink.href = url;
                downloadLink.download = "sd.png";
                downloadLink.click();
                
            }
            setIsWaiting(false);

        });
        let logmsg = `保存设备${props.item.Sn}中测点ID为 ${selNode}的时间，${startTime}到${endTime}之间的历史数据的${tabKey==='1'?'表格':
            tabKey==='2'?'时间轴曲线图':tabKey==='3'?'温度曲线':'湿度曲线'}形式的图片`;
        let log={
            operator:'',
            district:state.district.filter(item=>item.id===props.item.District)[0]?.name,
            content:logmsg,
            result:'导出成功',
            contentData:null
        }
        http.post('/v1/userlog', {
            user: state.main.id,
            type: 301,
            method: 'POST',
            log: JSON.stringify(log),
            time:formatDateTimes(new Date()),
            username:state.main.name,
            usertype:state.main.type,
            signa:''
        }).then(res => {
            console.log(res,'保存图片');
            
        })
    }

    const antdPointClick =(plot) => {
        plot.on('element:click', args => {
         const {x,y} = args
         let points = args.data.points;
         // let data = args.data.data;
         points = points.reverse()
         let ele = points.reduce((prec,cur)=>{
             let xLen = Math.abs(prec.x-x);
             let xLen1 = Math.abs(cur.x-x);
             let yLen = Math.abs(prec.y-y);
             let yLen1 = Math.abs(cur.y-y);
             if(Math.sqrt(xLen*xLen+yLen*yLen)<Math.sqrt(xLen1*xLen1+yLen1*yLen1)){
                 return prec
             }else{
                 return cur
             }
         });
         let index = points.findIndex(val=>val.x===ele.x&&val.y===ele.y)
         setTabKey('1');
         setTableCurrent(Math.ceil(index/tablePageSize))
       });
     }

    const exportExcel = ( type=0) => { 
        setIsWaiting(true);
        var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        let url = "/v1/"
        if(type!==0){
            url+="historydliteexcel?device=" + props.item.Sn + "&node=" +  selNode;
        }else {
            url+="historydexcel?device=" + props.item.Sn + "&node=" +  selNode;
        }
       
        startTime === ''?url +=  "&starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
        endTime===''? url+="&starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
        url+="&starttime=" + startTime + "&endtime=" + endTime;
        url+="&min="+minInterval;
        if(Mode==='soc'){
            fetch(url, { //downloadFiles 接口请求地址
                method: 'get',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                })
            })
            .then((response) => {
                setIsWaiting(false);
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                    let filename =  props.item.Name + '.xlsx';//设置文件名称
                    aElement.href = blobUrl;//设置a标签路径
                    aElement.download = filename;
                    aElement.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }).catch(error => {
                setIsWaiting(false);
                console.log('文件下载失败', error);
            });
        }else{
            if(window.CefSharp!==undefined){
                window.CefSharp.BindObjectAsync("bound");
                let path = window.bound.exportEXCEL(props.item.Name+'.xls');
                url+="&path=" + path;
                http.get(url, {}).then(data=>{
                    setIsWaiting(false);
                    if(data.code===0&&data.msg==="ok")message.success('EXCEL导出成功'+data.data,3);
                })
            }
        }
    }
    useEffect(() => {
        let todo = state.mainTodo;
        let todoCon = todo===''?null:JSON.parse(todo)
        let newMode = todoCon?.showHisModeNew?true:false
        let showLimit = todoCon?.showHisLimit===undefined?true:todoCon.showHisLimit
        setShowHisModeNew(newMode)
        setShowHisLimit(showLimit)
        Mode==='soc' && setUserName(state.district.filter(item => item.id === props.item.District)[0].user_name);
        Mode==='local'&&
        http.get("/v1/getconfig", {}).then(data => {
            if (data.code === 0) {
                setLocalCompany(data.data.Title)
            }
        })
        let unit = '℃';
        unit = props.item.Type===205?'Pa':(props.item.Type===210||props.item.Type===211)?'MPa':'℃';
        let unitName = '温度';
        unitName=(props.item.Type===205||props.item.Type===210||props.item.Type===211)?'压强':'温度';
        let tempWarnH = props.item.Sensor.TempWarningHigh
        let tempWarnL = props.item.Sensor.TempWarningLow
        let humiWarnH = props.item.Sensor.HumiWarningHigh
        let humiWarnL = props.item.Sensor.HumiWarningLow
       
        setShowUnit(unit);
        setShowUnitName(unitName);
        setStartTime(props.start);
        setEndTime(props.end)
        if(props.showMore){
            let isShowBoundWT = true
            let isShowBoundWH = true
            if(tempWarnH===tempWarnL){

                isShowBoundWT = false
            }
            if(humiWarnH===humiWarnL){
                isShowBoundWH = false
            }
            state_device.devicestate.filter(x=>x.Sn===props.item.Sn).map(m=>{
                if(isShowBoundWT){
                    if(m.Sensor.TempWarningHigh!==tempWarnH){
                        isShowBoundWT = false
                    }
                }
                if(isShowBoundWH){
                    if(m.Sensor.HumiWarningHigh!==humiWarnH){
                        isShowBoundWH = false
                    }
                }
                
            })
            setShowBoundWarnT(isShowBoundWT)
            setShowBoundWarnH(isShowBoundWH)
            let checkOptions = 
            state.main.type===101?  state.device.filter(x=>x.node!==0&&x.sn==props.item.Sn&&x.district==props.item.District)
            : 
            state.device.filter(x=>x.node!==0&&x.sn==props.item.Sn&&x.district==props.item.District&&(Mode==='local'?true :new Date(x.expire).getTime()>todayTime));
            let values =[];
            var nodes = new Array();
            checkOptions.map(m=>{
                m.value=m.id;
                m.label=m.name;
                values.push(m.id)
                nodes.push(m.node);
                m.key = m.id;
            })
            setShowSelDevNodes(checkOptions);
            setSelDevNodes(checkOptions)
            setSelNode(nodes);
            setShowSelDevNodesValue(values);
            setCheckedList(values);
            setTimeout(() => {
                getHistorys(nodes,props.start,props.end,unitName,checkOptions,newMode,showLimit)
            }, 100);
        }else{
            if(tempWarnH!==tempWarnL){
                setShowBoundWarnT(true)
            }
            if(humiWarnH!==humiWarnL){
                setShowBoundWarnH(true)
            }
            setSelNode(props.item.Node)
            getHistory(props.start,props.end,unitName,newMode,showLimit);
        }
        
    }, [state.mainTodo])
    useEffect(()=>{
        tempChart&& option && tempChart.setOption(option);
    },[seriesTempData])
    function getChartImage() {
        var imgUrl = myChartP&&myChartP.getDataURL({
            // 指定图片的宽度和高度
            pixelRatio: 1,
            backgroundColor: '#fff'
        });
        return imgUrl;
    }
  return (
    <div >
        {/*统计信息 最大 最小 平均值展示  */}
        <Spin size="large" spinning={isWaiting} style={{display:'flex',height:'100%',width:'100%'}}>
        <div style={{ padding: 5 }} className='flexCon' id='devicechart' >
            {/* 时间选择 间隔 查询 导出 */}
            <div style={{ marginBottom: '12px', fontSize: '14px', fontWeight: 'bold', flexDirection: 'row',  display: 'flex' ,justifyContent:'space-between'}}>
                
                {/* 自定义时间间隔查询*/}
                <div >
                    <RangePicker style={{borderRadius:10}}
                        allowEmpty={[false,true]}
                        ranges={{
                            今天: [moment().startOf('day'), moment()],
                            '本周': [moment().startOf('week'), moment().endOf('week')],
                            '本月': [moment().startOf('month'), moment().endOf('month')],
                            '前一天': [moment().subtract(1, 'days'), moment()],
                            '前三天': [moment().subtract(3, 'days'), moment()],
                            '前五天': [moment().subtract(5, 'days'), moment()],
                            '前七天': [moment().subtract(5, 'days'), moment()],
                            '一小时': [moment().subtract(1, 'hours'), moment()],
                            '三小时': [moment().subtract(3, 'hours'), moment()],
                            '五小时': [moment().subtract(5, 'hours'), moment()],
                            '六小时': [moment().subtract(6, 'hours'), moment()],
                        }}
                        showTime
                        format="YYYY-MM-DD HH:mm"
                        onChange={(dates, dateStrings) => {
                            if(dates===null){
                                setIsChangeTime(false)
                                setStartTime(props.start);
                                setEndTime(props.end);
                            }else{
                                setIsChangeTime(true)
                                setStartTime(dateStrings[0]+':00');
                                dates[1]!==null&&setEndTime(dateStrings[1]+':00');
                            }   
                        }}
                    />
                    <Select
                        showSearch
                        bordered
                        style={{ width: 80 ,marginLeft:10,marginRight:10 }}
                        placeholder="间隔"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={value=>setMinInterval(value)}
                    >
                        <Option value="1">1</Option>
                        <Option value="2">2</Option>
                        <Option value="5">5</Option>
                        <Option value="10">10</Option>
                        <Option value="20">20</Option>
                        <Option value="30">30</Option>
                        <Option value="60">60</Option>
                    </Select>
                    <Button type="primary" icon={<SearchOutlined />} style={{borderRadius:10}} disabled={isWaiting}
                    onClick={()=>{
                        // setLoading(true);
                        setIsWaiting(true);
                        setData([]);setDataF({ tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });setdataChart([]);
                        let startT = formatDateTimes(dateStart().getTime());
                        let endT = formatDateTimes(new Date().getTime());
                        if(isChangeTime){
                            props.showMore?getHistorys(selNode,startTime,endTime,showUnitName,selDevNodes):getHistory(startTime,endTime,showUnitName);
                        }else{
                            props.showMore?getHistorys(selNode,startT,endT,showUnitName,selDevNodes):getHistory(startT,endT,showUnitName);
                        }
                    }}>

                        查询
                    </Button>
                </div>
                {/* 导出 */}
                {
                    <div>
                        {/* 下载EXCEL */}
                        {
                            state.super>1&&
                            <Button style={{ marginLeft: 5,fontSize:12,borderRadius:10}} disabled={state.main.role.indexOf(304)===-1}
                            onClick={() => {
                                exportExcel()
                            }}>导出EXCEL</Button>
                        }
                        {
                            state.super>1&&
                            <Button style={{ marginLeft: 5,fontSize:12,borderRadius:10}} disabled={state.main.role.indexOf(304)===-1}
                            onClick={() => {
                                exportExcel(1)
                            }}>EXCEL(基础)</Button>
                        }
                        {/* 下载PDF */}
                        <Button style={{ marginLeft: 5,fontSize:12,borderRadius:10}} disabled={state.main.role.indexOf(304)===-1}
                        onClick={() => {
                            setIsWaiting(true);
                            var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
                            let url = "/v1/"
                            props.item?.Type===214?
                            url += "historydwpdf?device=" + props.item.Sn + "&node=" + selNode:
                            showHisModeNew?
                            url += "historydapdf?device=" + props.item.Sn + "&node=" +  selNode:
                            url += "historydpdf?device=" + props.item.Sn + "&node=" +  selNode;
                            startTime === ''?url +=  "&starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                            endTime===''? url+="&starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
                            url+="&starttime=" + startTime + "&endtime=" + endTime; 
                            url+="&min="+minInterval;
                            if(!isExportHumi){
                                url+="&humi=false"
                            };
                            if(Mode==='soc'){
                                fetch(url, { //downloadFiles 接口请求地址
                                    method: 'get',
                                    credentials: 'include',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    })
                                })
                                .then(response => {
                                    setIsWaiting(false);
                                    response.blob().then(blob => {
                                        let blobUrl =window.URL.createObjectURL(blob);
                                        let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                        let filename =  props.item.Name + '.pdf';//设置文件名称
                                        aElement.href = blobUrl;//设置a标签路径
                                        aElement.download = filename;
                                        aElement.click();
                                        window.URL.revokeObjectURL(blobUrl);
                                    });
                                }).catch((error) => {
                                    setIsWaiting(false);
                                    console.log('文件下载失败', error);
                                });
                            }else{
                                if(window.CefSharp!==undefined){
                                    window.CefSharp.BindObjectAsync("bound");
                                    let path = window.bound.exportPDF(props.item.Name+'.pdf');
                                    url+="&path=" + path;
                                    http.get(url, {}).then(data=>{
                                        setIsWaiting(false);
                                        if(data.code===0&&data.msg==="ok")message.success('PDF导出成功'+data.data,3);
                                    }).catch(error => {
                                        setIsWaiting(false);
                                    });
                                }
                            }
                        }}>导出PDF</Button>
                        {
                            !showHisModeNew&&
                            <Button style={{ marginLeft: 5,fontSize:12,borderRadius:10}} disabled={state.main.role.indexOf(304)===-1}
                            onClick={() => {
                                setIsWaiting(true);
                                var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
                                let url = "/v1/"
                                url += "historydpdf?device=" + props.item.Sn + "&node=" +  selNode;
                                startTime === ''?url +=  "&starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                                endTime===''? url+="&starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
                                url+="&starttime=" + startTime + "&endtime=" + endTime; 
                                url+="&min="+minInterval+"&power=false&door=false";
                                if(!isExportHumi){
                                    url+="&humi=false"
                                };
                                if(Mode==='soc'){
                                    fetch(url, { //downloadFiles 接口请求地址
                                        method: 'get',
                                        credentials: 'include',
                                        headers: new Headers({
                                            'Content-Type': 'application/json',
                                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                                        })
                                    })
                                    .then(response => {
                                        setIsWaiting(false);
                                        response.blob().then(blob => {
                                            let blobUrl =window.URL.createObjectURL(blob);
                                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                            let filename =  props.item.Name + '.pdf';//设置文件名称
                                            aElement.href = blobUrl;//设置a标签路径
                                            aElement.download = filename;
                                            aElement.click();
                                            window.URL.revokeObjectURL(blobUrl);
                                        });
                                    }).catch((error) => {
                                        setIsWaiting(false);
                                        console.log('文件下载失败', error);
                                    });
                                }else{
                                    if(window.CefSharp!==undefined){
                                        window.CefSharp.BindObjectAsync("bound");
                                        let path = window.bound.exportPDF(props.item.Name+'.pdf');
                                        url+="&path=" + path;
                                        http.get(url, {}).then(data=>{
                                            setIsWaiting(false);
                                            if(data.code===0&&data.msg==="ok")message.success('PDF导出成功'+data.data,3);
                                        }).catch(error => {
                                            setIsWaiting(false);
                                        });
                                    }
                                }
                            }}>PDF(基础版)</Button>
                        }
                        {/* <Button style={{ marginLeft: 5,fontSize:12,borderRadius:10,visibility:'hidden'}} disabled={state.main.role.indexOf(304)===-1} 
                        onClick={() => {
                            setIsWaiting(true);
                            var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
                            let url = "/v1/"
                            props.item?.Type===214?
                            url += "historyreportpdf?device=" + props.item.Sn + "&node=" + selNode:
                            url += "historyreportpdf?device=" + props.item.Sn + "&node=" +  selNode;
                            startTime === ''?url +=  "&starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                            endTime===''? url+="&starttime=" + startTime + "&endtime=" + formatDateTimes(new Date().getTime()):
                            url+="&starttime=" + startTime + "&endtime=" + endTime; 
                            url+="&min="+minInterval+"&power=false&door=false";
                            if(!isExportHumi){
                                url+="&humi=false"
                            };
                            if(Mode==='soc'){
                                fetch(url, { //downloadFiles 接口请求地址
                                    method: 'get',
                                    credentials: 'include',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                    })
                                })
                                .then(response => {
                                    setIsWaiting(false);
                                    response.blob().then(blob => {
                                        let blobUrl =window.URL.createObjectURL(blob);
                                        let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                        let filename =  props.item.Name + '.pdf';//设置文件名称
                                        aElement.href = blobUrl;//设置a标签路径
                                        aElement.download = filename;
                                        aElement.click();
                                        window.URL.revokeObjectURL(blobUrl);
                                    });
                                }).catch((error) => {
                                    setIsWaiting(false);
                                    console.log('文件下载失败', error);
                                });
                            }else{
                                if(window.CefSharp!==undefined){
                                    window.CefSharp.BindObjectAsync("bound");
                                    let path = window.bound.exportPDF(props.item.Name+'.pdf');
                                    url+="&path=" + path;
                                    http.get(url, {}).then(data=>{
                                        setIsWaiting(false);
                                        if(data.code===0&&data.msg==="ok")message.success('PDF导出成功'+data.data,3);
                                    }).catch(error => {
                                        setIsWaiting(false);
                                    });
                                }
                            }
                        }}>报告</Button> */}
                        {
                            props.item.Humi===1?<Checkbox style={{marginLeft:5}} checked={isExportHumi} onChange={(e)=>{
                                e.target.checked?setIsExportHumi(true):setIsExportHumi(false);
                            }}>湿度</Checkbox>:''
                        }
                        
                        <div>
                        {
                            Mode==='local' &&
                            <div>
                                {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                <span style={{color:'red',fontSize:10}}>只可导出不能导入</span>
                            </div>
                        }
                        </div>
                    </div>
                }
            </div>
            {/*  用户  区域  主机名 主机编号  测点名称 测点 */}
            <div >
                <div style={{border: '1px solid #F2F4F8',borderRadius:5,marginBottom:10,padding:10}}>
                    {
                        <span><span className='fontContentHis' style={{color:'#999'}}>用户: </span><span className='fontContentHis'>{Mode==='soc'?userName:localCompany}</span></span>
                    }
                    <span className='fontContentHis' style={{color:'#999',marginLeft:45}}>区域:</span>
                    <span  className='fontContentHis'>{state.district.filter(item=>item.id===props.item.District)[0]?.name}</span>
                </div>
                <div style={{display:'flex',backgroundColor:'#F2F4F8',borderRadius:'5px 5px 0px 0px',padding:10}}>                               
                    <span className='fontContentHis' style={{color:'#999'}}>主机名:</span> <span className='fontContentHis'>{props.item.MName}</span>
                    <span className='fontContentHis' style={{ marginLeft: '40px',color:'#999'}}>主机编号: </span> <span className='fontContentHis'>{props.item.Sn}</span>
                    {
                        props.showMore? 
                        <div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',flex:1}}>
                            <span margin-left='14px' style={{ fontSize: 14, marginLeft: 10 }}>测点</span>
                            <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                                全选
                            </Checkbox>
                        </div>:
                        <div style={{display:'flex',alignItems:'center',marginLeft:45}}>
                            <span className='fontContentHis'>{ props.item.Name}</span>
                            <span className='fontContentHis' style={{ marginLeft: '40px',color:'#999' }}>测点ID: </span> 
                            <span className='fontContentHis'>{props.item.Node}</span>
                        </div>
                    }
                </div>
                
            </div>
            {
                props.showMore&&
                <div>
                    <Checkbox.Group options={showSelDevNodes}  value={checkedList} onChange={onCheckChange}/>
                </div>
            }
            {/* 数据展示 */}
            <div className='flexCon'>
                <div style={{ padding: 5, border: '1px solid #ebedf1', }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: 100 }}>{props.item.Type===205?'压强(Pa)':'温度(℃)'}</div>
                        {showHisLimit&&<div style={{ width: 100 }}>上限值:{data.length > 0 ? data[0].temp_h : ''}</div>}
                        {showHisLimit&&<div style={{ width: 100 }}>下限值:{data.length > 0 ? data[0].temp_l : ''}</div>}
                        <div style={{ width: 100 }}>最大值:{dataF.tmax}</div>
                        <div style={{ width: 100 }}>最小值:{dataF.tmin}</div>
                        <div style={{ width: 100 }}>平均值:{dataF.tavg.toFixed(2)}</div>
                        <div style={{ width: 100 }}>湿度(%RH):</div>
                        {
                            isHumi&&showHisLimit&&<div style={{ width: 100 }}>上限值:{data.length > 0 ? data[0].humi_h : ''}</div>
                        }
                        {
                            isHumi&&showHisLimit&&<div style={{ width: 100 }}>下限值:{data.length > 0 ? data[0].humi_l : ''}</div>
                        }
                        {
                            isHumi&&<div style={{ width: 100 }}>最大值:{dataF.hmax}</div>
                        }
                        {
                            isHumi&&<div style={{ width: 100 }}>最小值:{dataF.hmin}</div>
                        }
                        {
                            isHumi&&<div style={{ width: 100 }}>平均值:{dataF.havg.toFixed(2)}</div>
                        }
                    </div>
            </div>
                {/* 图表展示 */}
                {
                    props.showMore?//多测点
                    <Tabs activeKey={tabKey} style={{height:'65vh',overflow:'auto'}} defaultActiveKey="1" 
                        tabBarExtraContent={
                            <div>
                                <a id="downloadDiv" style={{ display: 'none' }}></a>
                                {/* 保存为图片 */}
                                <Button style={{ borderRadius:10 ,fontSize:12}} onClick={saveImage}>保存为图片</Button>
                            </div>
                        } destroyInactiveTabPane={true} onChange={onChange_Tab} 
                    >
                        <Tabs.TabPane tab="报表显示" key="1">
                            <Table 
                                bordered
                                columns={props.item.Type===214?[...columnsLeft, ...selNodeColums]:[...columnsLeft, ...selNodeColums, ...columnsRight]}
                                scroll={{x:'80%'}}
                                style={{fontFamily:'PingFang SC',fontWeight:400,fontSize:14,color:'#333',lineHeight:16}}
                                size={'small'}  dataSource={data}  rowKey={record => record.data_time} loading={isWaiting} pagination={{ showSizeChanger:true,current: tableCurrent, onChange:onChange_Table,pageSize:tablePageSize,total:recordCount,hideOnSinglePage:true}}/>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="时间轴曲线图" key="2">
                            <div style={{border: '1px solid #ebedf1'}} className='flexCon'>
                                <div></div>
                                <div id='tempEcharts'></div>
                                <div style={{display:'flex',justifyContent:'space-between',paddingRight:'10%',paddingLeft:50}}>
                                    <div>
                                        <span>开始时间:</span>
                                        <span>{startTime}</span>
                                    </div>
                                    <div>
                                        <span>结束时间:</span>
                                        <span>{endTime}</span>
                                    </div>
                                </div>
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={showUnitName+'曲线'} key="3">
                            <div style={{ border: '1px solid #ebedf1', padding: 10 }}>
                                <Line {...configtemps} onReady={antdPointClick}/>
                            </div>
                            {
                                dataChart.length>0&&!showBound&&
                                <div style={{textAlign:'center'}}>
                                    <span style={{fontSize:10,color:'red'}}>您选择的测点包含多个温（湿）度区间或者是空库，故不展示区间辅助线</span>
                                </div>
                            }
                        </Tabs.TabPane>
                        {
                            isHumi&&
                            <Tabs.TabPane tab="湿度曲线" key="4">
                                <div style={{ border: '1px solid #ebedf1', padding: 10 }}>
                                    <div>
                                        <Line {...confighumis} onReady={antdPointClick}/>
                                    </div>
                                </div>
                                {
                                    dataChart.length>0&&!showBound&&
                                    <div style={{textAlign:'center'}}>
                                        <span style={{fontSize:10,color:'red'}}>您选择的测点包含多个温（湿）度区间或者是空库，故不展示区间辅助线</span>
                                    </div>
                                }
                            </Tabs.TabPane>
                        }
                    </Tabs>
                    ://单测点node0
                    props.item.Node===0?
                    <Tabs> 
                        <Tabs.TabPane tab="报表显示" key="1">
                            <Table bordered pagination={{ showSizeChanger:true,hideOnSinglePage:true }}  rowKey={record => record.id} columns={tableColums} size='small' dataSource={data} 
                            />
                        </Tabs.TabPane>
                    </Tabs>
                    ://单测点
                    <Tabs style={{height:'65vh',overflow:'auto',marginTop:15}} destroyInactiveTabPane={true} onChange={onChange_Tab} activeKey={tabKey} 
                    tabBarExtraContent={
                        <div>
                            <a id="downloadDiv" style={{ display: 'none' }}></a>
                                {/* 保存为图片 */}
                                <Button style={{ borderRadius:10 ,fontSize:12}} onClick={saveImage}>保存为图片</Button>
                                {
                                    tabKey==='2'&&
                                    <Button style={{ borderRadius:10 ,fontSize:12}} onClick={e=>{
                                        var printContent = document.querySelector('.print-me');
                                        var windowContent = printContent.innerHTML;
                                        let imgUrl = getChartImage();
                                        var printWindow = window.open('', '_blank');
                                        printWindow.document.write('<html><head><title>打印</title>');
                                        printWindow.document.write('</head><body >');
                                        printWindow.document.write(windowContent);
                                        printWindow.document.write("<img src='" + imgUrl + "' alt='ECharts 折线图'/>");
                                        printWindow.document.write('</body></html>');
                                        printWindow.document.close();
                                        printWindow.print();
                                        printWindow.close();
                                  }}>打印</Button>
                                }
                                
                        </div>
                    }
                    >
                        <Tabs.TabPane tab="报表显示" key="1" >
                            <Table bordered style={{fontFamily:'PingFang SC',fontWeight:400,fontSize:14,color:'#333',lineHeight:16}}  rowKey={record => record.id}
                            pagination={{ showSizeChanger:true,current: tableCurrent, onChange:onChange_Table,pageSize:tablePageSize,total:recordCount,hideOnSinglePage:true}}  columns={tableColums} size='small' dataSource={data}/>
                            
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="时间轴曲线图" key="2">
                            <div style={{border: '1px solid #ebedf1'}} className='flexCon '>
                                <div></div>
                                <div id='tempEcharts' ></div>
                                <div style={{display:'flex',justifyContent:'space-between',paddingRight:'10%',paddingLeft:50}}>
                                    <div>
                                        <span>开始时间:</span>
                                        <span>{startTime}</span>
                                    </div>
                                    <div>
                                        <span>结束时间:</span>
                                        <span>{endTime}</span>
                                    </div>
                                </div>
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={showUnitName+'曲线'} key="3">
                            <div style={{ border: '1px solid #ebedf1', padding: 10 }}>
                                <Line {...configtemp}  onReady={antdPointClick}/>
                            </div>
                        </Tabs.TabPane>
                        {
                            isHumi&&
                            <Tabs.TabPane tab="湿度曲线" key="4">
                                <div style={{ border: '1px solid #ebedf1', padding: 10 }}>
                                    <div>
                                        <Line {...confighumi} onReady={antdPointClick}/>
                                    </div>
                                </div>
                            </Tabs.TabPane>
                        }
                    </Tabs>
                }
                
            </div>
        </div>
        </Spin>
        <div className='print-me' style={{display:'none'}}>
            <div style={{fontSize:26}}>
                <span>设备编号：</span>
                <span style={{marginLeft:5}}>{props.item.Sn}</span>
                <span style={{marginLeft:10}}>用户：</span>
                <span style={{marginLeft:5}}>{state.main.name}</span>
                <span style={{marginLeft:10}}>单位：</span>
                <span style={{marginLeft:5}}>{userName}</span>
            </div>
            <div style={{fontSize:26}}>
                <span>区域：</span>
                <span style={{marginLeft:5}}>{state.district.filter(item=>item.id===props.item.District)[0].name}</span>
                <span style={{marginLeft:20}}>名称：</span>
                <span style={{marginLeft:5}}>{`${props.item.Name}-探头编号-${props.item.Node}`}</span>
            </div>
            <div style={{fontSize:26}}>
                <span>开始时间：</span>
                <span style={{marginLeft:5}}>{startTime}</span>
                <span style={{marginLeft:20}}>结束时间：</span>
                <span style={{marginLeft:5}}>{endTime}</span>
            </div>
            <div style={{fontSize:26}}>
                <span>温度</span>
                <span style={{marginLeft:20}}>最大值：</span>
                <span style={{marginLeft:5}}>{props.item.Type===211?dataF.tmax.toFixed(2):dataF.tmax.toFixed(1)}</span>
                <span style={{marginLeft:20}}>最小值：</span>
                <span style={{marginLeft:5}}>{props.item.Type===211?dataF.tmin.toFixed(2):dataF.tmin.toFixed(1)}</span>
                <span style={{marginLeft:20}}>平均值：</span>
                <span style={{marginLeft:5}}>{props.item.Type===211?dataF.tavg.toFixed(2):dataF.tavg.toFixed(1)}</span>
            </div>
            {
                props.item.Humi===1&&
                <div style={{fontSize:26}}>
                    <span>湿度</span>
                    <span style={{marginLeft:20}}>最大值：</span>
                    <span style={{marginLeft:5}}>{}</span>
                    <span style={{marginLeft:5}}>{props.item.Type===211?dataF.hmax.toFixed(2):dataF.hmax.toFixed(1)}</span>
                    <span style={{marginLeft:20}}>最小值：</span>
                    <span style={{marginLeft:5}}>{props.item.Type===211?dataF.hmin.toFixed(2):dataF.hmin.toFixed(1)}</span>
                    <span style={{marginLeft:20}}>平均值：</span>
                    <span style={{marginLeft:5}}>{props.item.Type===211?dataF.havg.toFixed(2):dataF.havg.toFixed(1)}</span>
                </div>
            }
            <div style={{fontSize:26}}>
                <table style={{textAlign:'center',fontSize:26}}>
                    <thead >
                        <tr>
                            <th style={{border:'1px solid #ccc'}}>时间</th>
                            <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                            {
                                props.item.Humi===1&&
                                <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderLeft:'1px solid #ccc'}}>湿度</th>
                            }
                            
                            <th style={{border:'1px solid #ccc'}}>时间</th>
                            <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                            {
                                props.item.Humi===1&&
                                <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderLeft:'1px solid #ccc'}}>湿度</th>
                            }
                            <th style={{border:'1px solid #ccc'}}>时间</th>
                            <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>温度</th>
                            {
                                props.item.Humi===1&&
                                <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>湿度</th>
                            }
                            {/* <th style={{border:'1px solid #ccc'}}>时间</th>
                            <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                            {
                                props.item.Humi===1&&
                                <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>湿度</th>
                            } */}
                        </tr>
                        
                    </thead>
                    <tbody>
                        {
                            dataP.map((item,index) => {
                                if(index%3===0){
                                    return<tr key={index}>
                                    <td style={{border:'1px solid #ccc'}}>{item.data_time}</td>
                                    <td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                        {item.temp_switch===0?'--':
                            (item.temp===102.2||item.temp===102.3||item.temp===-102.2||item.temp===-102.3)?'NL':item.type===211?item.temp.toFixed(2):item.temp.toFixed(1)}</td>
                                    {
                                        props.item.Humi===1&&
                                        <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                            {(item.humi===102.2||item.humi===102.3||item.humi===-102.2||item.humi===-102.3)?'NL':item.humi.toFixed(1)}
                                        </td>
                                    }
                                    {
                                         ((index+1)<recordCount)&&<td style={{border:'1px solid #ccc'}}>{data[index+1].data_time}</td>
                                    }
                                    {
                                        ((index+1)<recordCount)&&<td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                            {data[index+1].temp_switch===0?'--':
                                            (data[index+1].temp===102.2||data[index+1].temp===102.3||data[index+1].temp===-102.2||data[index+1].temp===-102.3)?'NL':data[index+1].type===211?data[index+1].temp.toFixed(2):data[index+1].temp.toFixed(1)
                                            }
                                        </td>
            
                                    }
                                    {
                                        ((index+1)<recordCount)&&props.item.Humi===1&&
                                        <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                            {(data[index+1].humi===102.2||data[index+1].humi===102.3||data[index+1].humi===-102.2||data[index+1].humi===-102.3)?'NL':data[index+1].humi.toFixed(1)}
                                        </td>
                                    }    
                                    {
                                         ((index+2)<recordCount)&&(<td style={{border:'1px solid #ccc'}}>{data[index+2].data_time}</td>)
                                    }
                                    {
                                         ((index+2)<recordCount)&&(<td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>
                                            {data[index+2].temp_switch===0?'--':(data[index+2].temp===102.2||data[index+2].temp===102.3||data[index+2].temp===-102.2||data[index+2].temp===-102.3)?'NL':
                                        data[index+2].type===211?data[index+2].temp.toFixed(2):data[index+2].temp.toFixed(1)}
                                        </td>)
                                    }
                                    {
                                        ((index+2)<recordCount)&&props.item.Humi===1&&
                                        <td style={{width:80,marginLeft:5,borderRight:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                            {(data[index+2].humi===102.2||data[index+2].humi===102.3||data[index+2].humi===-102.2||data[index+2].humi===-102.3)?'NL':data[index+2].humi.toFixed(1)}
                                        </td>
                                    }
                                    {/* {
                                         ((index+3)<recordCount)&&(<td style={{borderLeft:'1px solid #ccc'}}>{data[index+3].data_time}</td>)
                                    }
                                    {
                                         ((index+3)<recordCount)&&(<td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc'}}>{data[index+3].temp_switch===0?'--':
                            (data[index+3].temp===102.2||data[index+3].temp===102.3||data[index+3].temp===-102.2||data[index+3].temp===-102.3)?'NL':data[index+3].type===211?data[index+3].temp.toFixed(2):data[index+3].temp.toFixed(1)}</td>)
                                    }
                                    {
                                        ((index+3)<recordCount)&&props.item.Humi===1&&
                                        <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc'}}>
                                            {(data[index+3].humi===102.2||data[index+3].humi===102.3||data[index+3].humi===-102.2||data[index+3].humi===-102.3)?'NL':data[index+3].humi.toFixed(1)}
                                        </td>
                                    } */}
                                </tr>
                                }
                            }
                                
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  )
}

export default DeviceHistory